import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator, signInWithCustomToken } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const devConfig = {
  apiKey: "AIzaSyD0kzWXv71ae1Qb9qnKVjtEB1HOW0_lVDs",
  authDomain: "sahod-uat.firebaseapp.com",
  projectId: "sahod-uat",
  storageBucket: "sahod-uat.firebasestorage.app",
  messagingSenderId: "2660540086",
  appId: "1:2660540086:web:1ac09b0ec20a8690c0d017",
  measurementId: "G-JZNWCGKYBK",
};

const prodConfig = {
  apiKey: "AIzaSyCa-y81khU-WZBBC-CV8FnIfMEzmeCAdWo",
  authDomain: "sahod-production.firebaseapp.com",
  projectId: "sahod-production",
  storageBucket: "sahod-production.firebasestorage.app",
  messagingSenderId: "338011314280",
  appId: "1:338011314280:web:29ff6bd9f4b47bb9e183dd",
  measurementId: "G-84231608EM"
};

const firebaseConfig =
  process.env.REACT_APP_ENVIRONMENT === "production" ? prodConfig : devConfig;

// Log which Firebase environment is being used
console.log(
  `Firebase: Using ${
    process.env.REACT_APP_ENVIRONMENT === "production" ? "PRODUCTION" : "UAT"
  } environment`
);

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
// Region-pinned (asia-southeast1) — the same memoized instance every call site
// uses via getFunctions(undefined, "asia-southeast1"), so connecting it to the
// emulator below also connects theirs.
export const functions = getFunctions(app, "asia-southeast1");

// E2E only: point the SDK at the local Firebase emulators when explicitly asked.
// Off by default — normal dev, build:uat, and build:prod never set this flag, so
// production bundles never carry an emulator-connect path. Never put
// REACT_APP_USE_EMULATOR in a committed .env (CRA inlines REACT_APP_* at build
// time). See PRD_PlaywrightFirebaseMCP (D1/D5/D9).
//
// The `NODE_ENV !== "production"` guard is load-bearing: CRA inlines NODE_ENV as a
// string LITERAL, so in a prod build this reads `"production" !== "production"` →
// statically false → terser strips this whole block (emulator URLs + the __E2E_*
// hooks) from the bundle. Without it, CRA inlines `process.env` as an object lacking
// REACT_APP_USE_EMULATOR — runtime-safe (the && short-circuits) but terser can't prove
// it, so the dead emulator code would still ship as text. E2E uses `npm start`
// (NODE_ENV=development), so the block stays live there. Asserted by the CI D5 gate.
if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_USE_EMULATOR === "true") {
  connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "localhost", 8080);
  connectFunctionsEmulator(functions, "localhost", 5001);
  if (typeof window !== "undefined") {
    // E2E test hooks (emulator-only) — let Playwright sign a session in via a
    // custom token minted by the signInAs helper, and read the live token claims
    // so the helper can wait for the post-login claims refresh to settle before
    // any rules-gated write. Never present in prod: the whole block is gated
    // behind REACT_APP_USE_EMULATOR (D5).
    window.__E2E_signIn = (token) => signInWithCustomToken(auth, token);
    window.__E2E_claims = async () => {
      const u = auth.currentUser;
      if (!u) return null;
      // force-refresh (true) so we observe the final, settled claims and cache them
      return (await u.getIdTokenResult(true)).claims;
    };
  }
  console.log(
    "Firebase: connected to LOCAL EMULATORS (Auth 9099, Firestore 8080, Functions 5001)"
  );
}
